export default __webpack_public_path__ + "static/media/AdobeStock_332184233_x3.6ef9bdce.jpg";